<mat-form-field>
  <mat-select placeholder="Select..." (valueChange)="change()" [(ngModel)]="question.answer!.value" name="item">
    <mat-option *ngFor="let item of question.configuration.options" [value]="item.value">
      {{ item.key }}
    </mat-option>
  </mat-select>
</mat-form-field>
